import {isForYouRefreshEnabled} from '../../shared/for-you-feature-flags'
import type {ForYouItemAction} from '../../shared/for-you-item.types'
import {useMergeabilityData} from '../use-mergeability-data'
import {OverviewMergeControl} from './OverviewMergeControl'
import {OverviewUpdateBranchControl, getBranchUpdateRequirement} from './OverviewUpdateBranchControl'
import {useForYouActionErrors} from '../../shared/use-for-you-action-errors'

export function useOverviewBranchActions(itemName: string) {
  const {onUpdateBranchError, onQueueError, footer} = useForYouActionErrors()
  const data = useMergeabilityData()

  if (!isForYouRefreshEnabled() || !data || data.isClosedOrMerged) {
    return {actions: [], footer: null}
  }

  const actions: ForYouItemAction[] = [
    {
      id: 'merge-control',
      content: <OverviewMergeControl data={data} itemName={itemName} onQueueError={onQueueError} />,
    },
  ]

  // update branch goes left of merge-control
  if (getBranchUpdateRequirement(data)) {
    actions.unshift({
      id: 'update-branch',
      content: <OverviewUpdateBranchControl itemName={itemName} onError={onUpdateBranchError} />,
    })
  }

  return {actions, footer}
}
